import React from 'react';
import Container from '../Container/Container';
import style from './StockHeader.module.css';
import StockImg from '../StockImg/StockImg';

const StockHeader = ({ stock, title, subtitle, rightSection }) => {
  return (
    <div className={style.header}>
      <Container>
        <div className={style.flexSpaceBetween}>
          <div className={style.flex}>
            <StockImg symbol={stock.symbol} alt={stock.name} width="50" height="50" className={style.logo} />
            <div>
              <h1 className={style.title}>{title || stock.name}</h1>
              <p className={style.subtitle}>{subtitle || stock.symbol}</p>
            </div>
          </div>
          {rightSection &&
            <div>
              {rightSection}
            </div>
          }
        </div>
      </Container>
    </div>
  );
};

export default StockHeader;
